import React, { useEffect, useState } from "react";
import "./App.scss";
import { Box, Link } from "@mui/material";
import Fund from "./pages/Fund";
import Header from "./components/Header";
import Footer from "./components/Footer";
import FundDetail from "./pages/FundDetail";
import SubMenu from "./components/SubMenu";
import { getMenuData } from "./utils/getMenuData";
import { HashRouter, RouteObject, useRoutes } from 'react-router-dom';

const paths = {
  fundDetail: "fund-detail",
};

function App() {
  const [showFundDetail, setShowFundDetail] = useState(false);
  const [currentPath, setCurrentPath] = useState("");
  const [subMenus, setSubMenus] = useState<any[]>([]);
  const [dataFund, setDataFund] = useState<any>(null);
  const pathActive = window.location.pathname;
  const menuData = getMenuData(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const path = urlParams.get("path");
    switch (path) {
      case paths.fundDetail:
        setShowFundDetail(true);
        break;
      default:
        setShowFundDetail(false);
        break;
    }
  }, [currentPath, showFundDetail]);

  const handleFundClick = (data:any) => {
    const url = new URL(window.location.href);
    setDataFund(data)
    setCurrentPath(paths.fundDetail);
    url.searchParams.set("path", paths.fundDetail);
    url.searchParams.set("id", data.fundId);
    window.history.pushState({}, "", url.toString());
    setShowFundDetail(true);
  };

  const handleBackClick = () => {
    setShowFundDetail(false);
    const url = new URL(window.location.href);
    url.searchParams.delete("path");
    url.searchParams.delete("id");
    window.history.pushState({}, "", url.toString());
  };

  const handleHoverOnMenu = (subs: any[]) => {
    setSubMenus(subs);
  };

  const AppRoutes = () => {
    const route: RouteObject[] = [{
      path: '/',
      element: <Fund />
    }, {
      path: '/detail/:id',
      element: <FundDetail />
    }];
    return useRoutes(route);
  };

  return (
    <HashRouter basename={'/'}>
      <Box className="container">
        <Header />
        {/* <Box className="main-navigation">
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "80px",
            }}
          >
            {menuData &&
              menuData.map((item: any, index: number) => {
                return (
                  <Link
                    sx={{
                      textDecoration: "none",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      borderBottom: "1px solid #2f3246",
                      height: "80px",
                    }}
                    className={
                      item.href === pathActive ? "nav-active" : "nav-item"
                    }
                    href={item.href}
                    key={index}
                    onMouseOver={() => {
                      handleHoverOnMenu(item.subs);
                    }}
                  >
                    <div className="img-icon">
                      <img src={item.icon} alt={item.label} />
                    </div>
                    <div className="label">{item.label}</div>
                  </Link>
                );
              })}
          </Box>
        </Box> */}
        <Box className="main-content">
          <Box
            sx={{
              display: "flex",
            }}
          >
            <SubMenu
              onMouseOut={() => {
                setSubMenus([]);
              }}
              menus={subMenus}
              isOpen={subMenus?.length > 0}
            />
            <Box
              sx={{
                width: "100%",
              }}
              id="content-page"
            >
              {/* {!showFundDetail && <Fund handleFundClick={handleFundClick} />}
              {showFundDetail && <FundDetail onBackClick={handleBackClick} />} */}
              <AppRoutes />
            </Box>
          </Box>
        </Box>
        <Footer />
      </Box>
    </HashRouter>
  );
}

export default App;
